import React, { useState } from "react";
import "./navmenu.css";
const menuItems = [
  {
    title: "By category",
    url: "/",
    submenu: [
      { title: "All", url: "/" },
      {
        title: "Rings",
        url: "/",
        submenu: [
          { title: "All rings", url: "/home/rings" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/rings/u1500" },
          { title: "1500-3000", url: "/home/rings/15h30h" },
          { title: "3000-5000", url: "/home/rings/30h50h" },
          { title: "above 5000", url: "/home/rings/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/rings/silver" },
          { title: "Pure Gold", url: "/home/rings/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/rings/silver" },
          { title: "Gold Plated", url: "/home/rings/goldplated" },
          { title: "Rose Gold", url: "/home/rings/rosegold" },
          { title: "Oxidised", url: "/home/rings/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/rings/everyday" },
          { title: "office", url: "/home/rings/office" },
          { title: "Party", url: "/home/rings/party" },
        ],
      },
      {
        title: "Necklaces & Pendants",
        url: "/",
        submenu: [
          {
            title: "All Necklaces & Pendants",
            url: "/",
          },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/necklaces&Pendants/u1500" },
          { title: "1500-3000", url: "/home/necklaces&Pendants/15h30h" },
          { title: "3000-5000", url: "/home/necklaces&Pendantss/30h50h" },
          { title: "above 5000", url: "/home/necklaces&Pendants/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/necklaces&Pendants/silver" },
          { title: "Pure Gold", url: "/home/necklaces&Pendants/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/necklaces&Pendants/silver" },
          { title: "Gold Plated", url: "/home/necklaces&Pendants/goldplated" },
          { title: "Rose Gold", url: "/home/necklaces&Pendants/rosegold" },
          { title: "Oxidised", url: "/home/necklaces&Pendants/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/necklaces&Pendants/everyday" },
          { title: "office", url: "/home/necklaces&Pendants/office" },
          { title: "Party", url: "/home/necklaces&Pendants/party" },
        ],
      },
      {
        title: "Bracelets",
        url: "/",
        submenu: [
          { title: "All Bracelets", url: "/" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/bracelets/u1500" },
          { title: "1500-3000", url: "/home/bracelets/15h30h" },
          { title: "3000-5000", url: "/home/bracelets/30h50h" },
          { title: "above 5000", url: "/home/bracelets/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/bracelets/silver" },
          { title: "Pure Gold", url: "/home/bracelets/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/bracelets/silver" },
          { title: "Gold Plated", url: "/home/bracelets/goldplated" },
          { title: "Rose Gold", url: "/home/bracelets/rosegold" },
          { title: "Oxidised", url: "/home/bracelets/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/bracelets/everyday" },
          { title: "office", url: "/home/bracelets/office" },
          { title: "Party", url: "/home/bracelets/party" },
        ],
      },
      {
        title: "Earrings",
        url: "/",
        submenu: [
          { title: "All Earrings", url: "/home/earrings" },
          { title: "Shop by price", url: "/" },
          { title: "Under 1500", url: "/home/earrings/u1500" },
          { title: "1500-3000", url: "/home/earrings/15h30h" },
          { title: "3000-5000", url: "/home/earrings/30h50h" },
          { title: "above 5000", url: "/home/earrings/50h" },
          { title: "Shop by Metal", url: "/" },
          { title: "925 Silver", url: "/home/earrings/silver" },
          { title: "Pure Gold", url: "/home/earrings/gold" },
          { title: "Shop by Colour", url: "/" },
          { title: "Silver", url: "/home/earrings/silver" },
          { title: "Gold Plated", url: "/home/earrings/goldplated" },
          { title: "Rose Gold", url: "/home/earrings/rosegold" },
          { title: "Oxidised", url: "/home/earrings/oxidised" },
          { title: "Shop by Style", url: "/" },
          { title: "Everyday", url: "/home/earrings/everyday" },
          { title: "office", url: "/home/earrings/office" },
          { title: "Party", url: "/home/earrings/party" },
        ],
      },
    ],
  },
  {
    title: "About",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/about/submenu1" },
      { title: "Submenu 2", url: "/about/submenu2" },
    ],
  },
  {
    title: "Services",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/services/submenu1" },
      { title: "Submenu 2", url: "/services/submenu2" },
    ],
  },
  {
    title: "Contact",
    url: "/",
    submenu: [
      { title: "Submenu 1", url: "/contact/submenu1" },
      { title: "Submenu 2", url: "/contact/submenu2" },
    ],
  },
];

function MenuItem({ item }) {
  const [showSubmenu, setShowSubmenu] = useState(false);

  const handleMouseEnter = () => {
    setShowSubmenu(true);
  };

  const handleMouseLeave = () => {
    setShowSubmenu(false);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <a href={item.url}>{item.title}</a>
      {showSubmenu && item.submenu && (
        <div className="submenu">
          {item.submenu.map((subItem, index) => (
            <MenuItem key={index} item={subItem} />
          ))}
        </div>
      )}
    </div>
  );
}

const Navmenu = () => {
  return (
    <div>
      <div className="menu">
        {menuItems.map((item, index) => (
          <MenuItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default Navmenu;
